import React from 'react'

export const Body = ({children}: React.PropsWithChildren) => {
  return <div>{children}</div>
}
